import SimulationCard from './SimulationCard'
export default SimulationCard
